module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "spinner"
  }, [_c('div', {
    staticClass: "icon icon--ei-spinner-2 icon--m"
  }, [_c('div', {
    staticClass: "icon__spinner"
  }, [_c('svg', {
    staticClass: "icon__cnt",
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 50 50"
    }
  }, [_c('circle', {
    attrs: {
      "cx": "25",
      "cy": "10",
      "r": "2"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "opacity": ".3",
      "cx": "25",
      "cy": "40",
      "r": "2"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "opacity": ".3",
      "cx": "32.5",
      "cy": "12",
      "r": "2"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "opacity": ".3",
      "cx": "17.5",
      "cy": "38",
      "r": "2"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "opacity": ".93",
      "cx": "17.5",
      "cy": "12",
      "r": "2"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "opacity": ".3",
      "cx": "32.5",
      "cy": "38",
      "r": "2"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "opacity": ".65",
      "cx": "10",
      "cy": "25",
      "r": "2"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "opacity": ".3",
      "cx": "40",
      "cy": "25",
      "r": "2"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "opacity": ".86",
      "cx": "12",
      "cy": "17.5",
      "r": "2"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "opacity": ".3",
      "cx": "38",
      "cy": "32.5",
      "r": "2"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "opacity": ".44",
      "cx": "12",
      "cy": "32.5",
      "r": "2"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "opacity": ".3",
      "cx": "38",
      "cy": "17.5",
      "r": "2"
    }
  })])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-4bff05f0!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Spinner.vue
// module id = 2143
// module chunks = 0